import { useEffect, useRef } from 'react';
import { usePopupContext } from '../PopupContext';
/**
 *  https://jira.tcsbank.ru/browse/UIKIT-6581
 */
const usePopupOrder = ({
  opened,
  popupRef
}) => {
  const setPrevLengthRef = useRef();
  const popupContext = usePopupContext();
  const isPopupContextDefined = typeof popupContext !== 'undefined';
  useEffect(() => {
    setPrevLengthRef.current = popupContext == null ? void 0 : popupContext.setPrevLength;
  }, [popupContext == null ? void 0 : popupContext.setPrevLength]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (opened && isPopupContextDefined && popupRef) {
      setPrevLengthRef == null ? void 0 : setPrevLengthRef.current == null ? void 0 : setPrevLengthRef.current();
      popupContext.setPopups(p => [...p, popupRef]);
    } else if (!opened && isPopupContextDefined && popupRef) {
      setPrevLengthRef == null ? void 0 : setPrevLengthRef.current == null ? void 0 : setPrevLengthRef.current();
      popupContext.setPopups(p => p.filter(ref => ref !== popupRef));
    }
  }, [opened, isPopupContextDefined, popupRef]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return {
    popupsLength: isPopupContextDefined ? popupContext.popups.length : 0,
    prevPopupsLength: isPopupContextDefined ? popupContext.popupsPrevLength : 0,
    isPopupContextDefined,
    isPopupLast: !isPopupContextDefined || isPopupContextDefined && !!popupRef && popupContext.popups.indexOf(popupRef) === popupContext.popups.length - 1
  };
};
export default usePopupOrder;